'use client';
import cn from 'classnames';

import Image from 'next/image';
import { Tooltip } from 'react-tooltip';

import Text from '@/components/common/Text/Text';

import Close from 'public/img/icon/close.svg';

import { CMSPlainImageData } from '../component-registry';

import LogoInPinkCircle from 'public/img/logo/vivrelle-logo-in-pink-circle.png';

import './PlanTierTable.style.scss';

export type tierItemProps = {
  className?: string;
  icon: string;
  items: ItemProps[];
  numberOfItems: string;
  tierName: string;
  tierPrice: string;
};

export type ItemProps = {
  itemName: string;
  itemImage: CMSPlainImageData;
  itemIndex: number;
  tierIndex: number;
};

type PlanTierTableProps = {
  className?: string;
  topHeadline: string;
  tierItems: tierItemProps[];
};

export function PlanTierTableItem(props: ItemProps) {
  const { itemName, itemImage, itemIndex, tierIndex } = props;

  return (
    <div className='PlanTierTable-item'>
      {itemIndex > 0 && <i>+</i>}

      <button
        className={`item-tooltip-anchor-${tierIndex}-${itemIndex} cursor`}
      >
        {itemName}
      </button>

      <Tooltip
        anchorSelect={`.item-tooltip-anchor-${tierIndex}-${itemIndex}`}
        className='PlanTierTable-tooltip cursor'
        classNameArrow='PlanTierTable-tooltip-arrow'
        opacity={1}
        place='top'
      >
        <Image
          className='PlanTierTable-close'
          src={Close}
          alt=''
          height={20}
          width={20}
        />

        <Image
          className={cn('PlanTierTable-item-image')}
          src={itemImage.image}
          alt={itemImage.imageAltText}
          height={itemImage.imageHeight}
          width={itemImage.imageWidth}
        />
      </Tooltip>
    </div>
  );
}

function PlanTierTable(props: PlanTierTableProps) {
  const { className = '', topHeadline, tierItems } = props;

  return (
    <div className={cn('PlanTierTable', className)}>
      <Text
        className='top-headline'
        variant='title-xl'
        italic
      >
        {topHeadline}
      </Text>

      <table>
        <thead>
          <tr>
            <th className='PlanTierTable-tier-header-cell'>
              <Image
                src={LogoInPinkCircle}
                className='vivrelle-logo'
                alt='Vivrelle logo in pink circle'
                height={14}
                width={14}
              />
              Tier
            </th>
            <th>Price</th>
            <th>
              Number
              <br />
              of items
            </th>
            <th>
              Sample
              <br />
              Month
            </th>
          </tr>
        </thead>
        <tbody>
          {tierItems &&
            tierItems.map((tierItem, tierIndex) => {
              return (
                <tr key={tierIndex}>
                  <td>
                    <Image
                      className={cn('PlanTierTable-icon')}
                      src={tierItem.icon}
                      alt=''
                      height={12}
                      width={12}
                    />
                    <p>{tierItem.tierName}</p>
                  </td>

                  <td>
                    {tierItem.tierName.match(/premier/i) ? (
                      <>
                        <p>Add on only:</p>
                        <p>${tierItem.tierPrice}</p>
                      </>
                    ) : (
                      <p>${tierItem.tierPrice}</p>
                    )}
                  </td>

                  <td>
                    <p>{tierItem.numberOfItems}</p>
                  </td>

                  <td>
                    {tierItem.items &&
                      tierItem.items.map((item, itemIndex) => {
                        return (
                          <PlanTierTableItem
                            key={itemIndex}
                            itemName={item.itemName}
                            itemImage={item.itemImage}
                            itemIndex={itemIndex}
                            tierIndex={tierIndex}
                          />
                        );
                      })}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
}

export default PlanTierTable;
